export const SERVICE_TYPES = [
  {
    key: 'service_desk',
    label: 'JIRA',
  },
]
